import React, { useRef, useEffect } from 'react';

import {
  LoadingType,
  PreQualificationStep,
  setLoadingState,
  setPreQualificationStep,
} from 'prequalificationV2/actions';
import { setBorrower } from 'prequalificationV2/actions/borrower';
import Loader from 'components/Loader';
import { PROVE_COMPLETE_AUTH_LOADER_TIMEOUT_IN_MS } from 'constants/constants';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import useAppNavigate from 'hooks/useAppNavigate';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import useQueryParam from 'hooks/useQueryParam';
import { AppRoutes } from 'prequalificationV2/routes/routes.enums';
import { convertDateFormat } from 'prequalificationV2/utils/dateUtils';
import { removeNonDigits } from 'prequalificationV2/utils/stringUtils';
import { proveApi } from 'api/ProveApi';
import { setIsBorrowerManualFlow } from 'prequalificationV2/actions/application';

const CompleteMobileAuth = () => {
  const dispatch = useAppDispatch();
  const vfp = useQueryParam('vfp');
  const navigator = useAppNavigate();
  const completeAuthLoaderTimerIdRef = useRef<number | undefined>(undefined);

  const borrowerState = useAppSelector((state) => state.borrower);

  useEffect(() => {
    const runCompleteAuthWithVfp = async () => {
      try {
        const completeAuthResult = await proveApi.completeMobileAuth({
          vfp: vfp as string,
          phoneNumber: removeNonDigits(borrowerState.phone),
          dob: convertDateFormat(borrowerState.dateOfBirth),
        });

        if (!!completeAuthResult?.success) {
          await dispatch(setBorrower({ ...completeAuthResult?.data, eligible: true }));
        } else {
          await dispatch(setIsBorrowerManualFlow(true));
        }
      } catch (err) {
        await dispatch(setIsBorrowerManualFlow(true));
        dispatch(setLoadingState({ type: LoadingType.GetData, loading: false }));
      } finally {
        completeAuthLoaderTimerIdRef.current = window.setTimeout(() => {
          navigator(AppRoutes.Prequalification);
          dispatch(setPreQualificationStep(PreQualificationStep.LoanInformation));
        }, PROVE_COMPLETE_AUTH_LOADER_TIMEOUT_IN_MS);
      }
    };

    runCompleteAuthWithVfp();

    return () => {
      window.clearTimeout(completeAuthLoaderTimerIdRef.current);
    };
  }, []);

  return (
    <>
      <Loader />
    </>
  );
};

export default CompleteMobileAuth;
